function initHeaderScroll() {
  const compareHeaderRow = $('.sh-compare-row.sh-compare-header');
  const targetPosition = compareHeaderRow.offset().top;

  $(window).on('scroll', function () {
    if ($(window).width() < 992)
      return true;

    const scrollPosition = $(window).scrollTop();
    if (scrollPosition > targetPosition) {
      compareHeaderRow.addClass('sh-sticky');
      compareHeaderRow.parent().css('padding-top', '250px')
    } else {
      compareHeaderRow.removeClass('sh-sticky');
      compareHeaderRow.parent().css('padding-top', '0px')
    }
  });
}

function initMobileTabs() {
  $(document).on('click', '.sh-compare-row-label', function () {
    const curLabel = $(this);
    curLabel.toggleClass('active');
    curLabel.parent().parent().find('.sh-vendor-card').toggleClass('active');
  })
}

function initCompareGallery() {
  $(document).on('click', '.sh-compare-gallery button', function () {
    const galleryWrap = $(this).parent().parent();
    const galleryData = galleryWrap.data('gallery');
    const env = galleryWrap.data('env');
    const isVideoGallery = $(this).data('video-gallery');
    let galleryElements = [];
    galleryData.map(item => {
      const subHtml = `<h4>${item.title}</h4><p>${item.description}</p>`;

      if (item.id && !isVideoGallery)
        galleryElements.push({
          src: `${env}/fit/600x600/${item.id}`,
          thumb: `${env}/fit/304x182/${item.id}`,
          subHtml: subHtml,
        })

      if (isVideoGallery && item.type == 1 && item.link) {
        galleryElements.push({
          src: `https://player.vimeo.com/video/${item.link}`,
          subHtml: subHtml,
          iframe: true,
        })
      }

      if (isVideoGallery && item.type == 0 && item.link) {
        galleryElements.push({
          src: `https://www.youtube.com/embed/${item.link}`,
          subHtml: subHtml,
          iframe: true,
        })
      }
    });

    $(this).lightGallery({
      dynamic: true,
      dynamicEl: galleryElements,
      loadYoutubeThumbnail: true,
      youtubeThumbSize: 'default',
      loadVimeoThumbnail: true,
      vimeoThumbSize: 'thumbnail_medium',
      thumbnail: false,
      rotate: false,
      flipHorizontal: false,
      flipVertical: false,
      share: false,
      autoplay: false,
      autoPlay: false,
      actualSize: false,
      pager: true,
    });
  });
}

function initComparedRemove() {
  $('.sh-vendor-card').on('click', '.sh-card-close', function () {
    const vendorPosition = $(this).closest('.sh-vendor-position').data('vendor-position');
    removeColumn(vendorPosition);
    syncItemsInRequestFromAll();
  })
}

function removeColumn(vendorPosition) {
  $('#sh-compare-about-' + vendorPosition).html('');
  $('#sh-compare-competitors-' + vendorPosition).html('');
  $('#sh-compare-employees-' + vendorPosition).html('');
  $('#sh-compare-features-' + vendorPosition).html('');
  $('#sh-compare-founded-' + vendorPosition).html('');
  $('#sh-compare-funding-summary-' + vendorPosition).html('');
  $('#sh-compare-links-' + vendorPosition).html('');
  $('#sh-compare-lives-serviced-' + vendorPosition).html('');
  $('#sh-compare-location-' + vendorPosition).html('');
  $('#sh-compare-media-' + vendorPosition).html('');
  $('#sh-compare-min-group-size-' + vendorPosition).html('');
  $('#sh-compare-resources-' + vendorPosition).html('');
  $('#sh-compare-product-description-' + vendorPosition).html('');
  $('#sh-compare-product-specific-features-' + vendorPosition).html('');
  $('#sh-compare-reviews-' + vendorPosition).html('');

  $(`#sh-compare-header-${vendorPosition} > div`).not('.sh-add-vendor').remove();
  $(`#sh-compare-header-${vendorPosition} .sh-add-vendor`).removeClass('sh-hidden');
  $(`#sh-compare-header-${vendorPosition} .sh-card-close`).attr('data-vendor-slug', '');
}

function syncItemsInRequestFromAll() {
  const onclickData = $('.request-from-all').attr('onclick');
  const onClickArray = onclickData.split(', ');
  if (onClickArray.length == 3) {
    let vendorSlugs = JSON.stringify(getVendorSlugs());

    const newString = onClickArray[0] + ', ' + vendorSlugs + ', ' + onClickArray[2];
    $('.request-from-all').attr('onclick', newString);
  }
}

function getVendorSlugs() {
  let vendorsSlugs = [];

  $('.sh-vendor-card .sh-card-close').each(function () {
    const slug = $(this).data('vendor-slug').trim();
    if (slug != '') {
      vendorsSlugs.push({'slug': slug});
    }
  });

  return vendorsSlugs;
}

function initAddCompareVendor() {
  const sampleHtml = '<div class="sh-vendor-result-card" ><div class="img_wrap"><img src="[logo]" alt="" /></div><h2>[name]</h2><button class="sh-button-primary" data-vendor-slug="[slug]"><span class="loading-more"><span class="spinner"><i class="fa fa-spinner fa-spin"></i></span></span><span class="sh-add-single-vendor">+ Add</span></button></div>';

  const productId = $('#productId').val();
  const envUrl = $('#envUrl').val();
  let searchTerm = '';
  let vendorPageIndex = 0;
  let vendorPositionToAdd = 0;

  function hideNoContent() {
    $('.sh-vendor-card').removeClass('sh-no-content');
    $('.sh-vendor-card').each(function () {
      const content = $(this).html().trim();
      if (content.length == 0)
        $(this).addClass('sh-no-content')
    })
  }

  hideNoContent();

  function getActiveVendors() {
    let vendors = [];
    $('.sh-data-vendor-compare').each(function () {
      vendors.push($(this).data('vendor-id').toString())
    })
    return vendors;
  }

  function renderVendors() {
    let htmlResult = '';
    const excludeVendors = getActiveVendors();
    const maxVendors = window.vendorsPerProduct.filter(vendor => !excludeVendors.includes(vendor.id)).filter((item) => item.name.toLowerCase().includes(searchTerm)).length;

    window.vendorsPerProduct.filter(vendor => !excludeVendors.includes(vendor.id)).filter((item) => item.name.toLowerCase().includes(searchTerm)).map(function (item, index) {
      if (index >= vendorPageIndex && index < vendorPageIndex + 3)
        htmlResult += sampleHtml.replace('[slug]', item.slug).replace('[logo]', `${envUrl}/fit/176x104/${item.logo}`).replace('[name]', item.name)
    });
    if (vendorPageIndex === 0)
      $('.sh-vendor-results').html(htmlResult);
    else
      $('.sh-vendor-result-card:last').after(htmlResult);

    vendorPageIndex += 3;
    if (vendorPageIndex >= maxVendors)
      $('#show-more-vendors').hide();
    else
      $('#show-more-vendors').show();
  }

  $(document).on('click', '.btn-add-vendor', function () {
    searchTerm = '';
    let htmlResult = '';
    const excludeVendors = getActiveVendors();
    window.vendorsPerProduct.filter(vendor => !excludeVendors.includes(vendor.id)).map(function (item, index) {
      if (index < 3)
        htmlResult += sampleHtml.replace('[slug]', item.slug).replace('[logo]', `${envUrl}/fit/176x104/${item.logo}`).replace('[name]', item.name)
    });
    $('.sh-vendor-results').html(htmlResult);
    vendorPageIndex += 3;

    vendorPositionToAdd = $(this).closest('.sh-vendor-position').data('vendor-position');

  });

  $(document).on('click', '#show-more-vendors', function () {
    renderVendors();
  })

  //show initial suggested vendors
  $(document).on('keydown', '#search-compare-vendor', function (e) {
    vendorPageIndex = 0;
    searchTerm = e.target.value.toLowerCase();
    renderVendors();
  });

  $(document).on('click', '.sh-vendor-result-card button', function () {
    $(this).find('.loading-more').addClass('active');
    $(this).find('.sh-add-single-vendor').addClass('sh-hidden');
    const vendorSlug = $(this).data('vendor-slug');
    $('.sh-vendor-result-card button').addClass('disabled');
    $(this).removeClass('disabled');

    $.ajax({
      url: window.ajax.url,
      data: {
        action: 'get_vendor',
        productId: productId,
        vendorSlug: vendorSlug,
      },
      success: function (result) {
        $(this).find('.loading-more').removeClass('active');
        $(this).find('.sh-add-single-vendor').removeClass('sh-hidden');
        Object.keys(result.data).map(item => {
          $(`#sh-compare-${item.replaceAll('_', '-')}-${vendorPositionToAdd}`).html(result.data[item])
        });

        $('.sh-modal-close').click();
        syncItemsInRequestFromAll();
        hideNoContent();
      },
      error() {
        $('.sh-modal-close').click();
      },
    });
  });
}

export default function compareVs() {
  initHeaderScroll();
  initMobileTabs();
  initCompareGallery();
  initComparedRemove();
  initAddCompareVendor();
}
